import React from 'react'
import './Footer.css';
const Footer = () => {
	return (
		<div className="bg-dark footer text-light">
			<p className="text-center mb-0">Copyright@2022 <span className="fw-bold  text-light ">React-Quizers</span></p>
		</div>
	)
}

export default Footer